import { render, staticRenderFns } from "./keyboard-events.vue?vue&type=template&id=6c445201&scoped=true&"
import script from "./keyboard-events.vue?vue&type=script&lang=js&"
export * from "./keyboard-events.vue?vue&type=script&lang=js&"
import style0 from "./keyboard-events.vue?vue&type=style&index=0&id=6c445201&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../@vue-modules/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c445201",
  null
  
)

export default component.exports